import moment from 'moment';
import type { App } from 'vue';

export const dateFormatterPlugin = {
  install: (app: App) => {
    function toDate(value: string) {
      if (!value || value === '-') return '-';
      return moment(value).format('L'); // '06/04/1973'
    }
    app.provide('useToDate', toDate);
    function toFullDate(value: string) {
      if (!value || value === '-') return '-';
      return moment(value).format('ll'); // 'Jun 4, 1973'
    }
    app.provide('useToFullDate', toFullDate);
    function toDateTime(value: string) {
      if (!value || value === '-') return '-';
      return moment(value).format('L LT'); // '06/04/1973 12:00 AM'
    }
    app.provide('useToDateTime', toDateTime);
    function toFullDateTime(value: string) {
      if (!value || value === '-') return '-';
      return moment(value).format('lll'); // 'Jun 4, 1973 12:00 AM'
    }
    app.provide('useToFullDateTime', toFullDateTime);
  },
};
